import { SprinklerIcon } from './SprinklerIcon';

/**
 * author: Michael Irigoyen
 * id 3B348D41-66D2-4CC7-894A-1C2E9EE64C7F
 * name sprinkler
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sprinkler.svg
 * tags
 * - Home Automation 
 * - Agriculture 
 */
export const IrrigationIcon = SprinklerIcon;
export default IrrigationIcon